import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '@ceslicensing/toast-notification';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { CommonHttpApiService } from '../http-services/common-http-api.service';
import { TokenService } from '@app/shared/services/token.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(
    private injector: Injector,
    private toast: ToastService,
    private tokenSerice: TokenService
  ) {}

  /* Error handling fn in whole application,
   * will check for server and throw other errors which can occur
   * Use console.log(error) for debugging
   */
  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
      if (error.status == 401) {
        this.toast.error('Something went wrong, Please try again later.');
      } else if (error.status == 400 && error.error && Object.keys(error.error).length) {
        let keyName = Object.keys(error.error)[0];
        if (keyName) {
          this.toast.error(error.error[keyName][0]);
        }
      } else if (error.status == 412 && error?.error?.msg) {
        this.toast.error(error.error.msg);
      } else {
        this.toast.error('Something went wrong, Please try again later.');
      }
    }
  }

  /* Check if server is alive, if not redirect to site-maintenance page */
  checkBackendIsUp() {
    const apiService = this.injector.get(CommonHttpApiService);
    const router = this.injector.get(Router);
    apiService
      .checkBackedIsUp()
      .pipe()
      .subscribe(() => {
        router.navigate([`/auth/site-maintenance`]);
      });
  }

  /**
   * API error handler
   */
  apiErrorHandle(error, msg?, mode?) {
    if (msg) {
      if (error?.error?.msg) {
        if (mode) this.toast[mode](error.error.msg);
        else this.toast.error(error.error.msg);
      } else {
        if (mode) this.toast[mode](msg);
        else this.toast.error(msg);
      }
    }
    if (error.status === 401) {
      this.toast.error('Something went wrong, Please try again later.');
      this.tokenSerice.checkSession();
    }
  }

  /**
   * Handle 401 error unautherized error
   */
  handle401Error(error, msg?) {
    if (error.status === 401) {
      this.toast.error('Your session has expired, Please try login again.');
      this.tokenSerice.checkSession();
    } else if (msg) {
      this.toast.error(msg);
    } else {
      this.toast.error('Something went wrong, Please try again later.');
    }
  }
}
